import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: { notification: null, addIncomingInventoryBlinker: false ,currentActiveRoute: "forecastReportPage" },
  reducers: {
    showNotification(state, action) {
      state.notification = {
        status: action.payload.status,
        title: action.payload.title,
        message: action.payload.message,
      };
    },
    showProgressBar(state, action) {
      state.progressbar = {
        status: action.payload.status,
        title: action.payload.title,
        progress: action.payload.progress,
        message: action.payload.message,
      };
    },
    setAddIncomingInventoryBlinker(state, action) {
      state.addIncomingInventoryBlinker = {
        value: action.payload.value,
      };
    },
    setCurrentActiveRoute(state, action) {
      state.currentActiveRoute = action.payload.currentActiveRoute;
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice;
